import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { viewCouponList, EditCoupon } from "../../Redux/Actions/couponsAction";
import { columnsCoupons } from "../../Global Functions/columnsAntd";
import DateRangePopup from "../../Utils/dateFilterPopup";
import TableComponentCp from "../../Global Functions/tableComponentsCp";

const ListCoupons = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchDetails = useCallback((page, limit) => {
    const couponData = {
      page,
      limit,
      status: [],
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };
    dispatch(viewCouponList(couponData));
  }, [dateRange.end, dateRange.start, debouncedSearch, dispatch])

  const { coupons, loading } = useSelector((state) => state.coupons);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (coupons?.total !== undefined) {
      setPagination((prev) => ({
        ...prev,
        total: coupons.total,
      }));
    }
  }, [coupons?.total]);

  const handleTableChange = ({ current, pageSize }) => {
    setPagination((prev) => ({
      ...prev,
      current,
      pageSize,
    }));
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
      setPagination((prev) => ({ ...prev, current: 1 }));
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);


  const handleStatusChange = async (record, action) => {
    let payload = { id: record._id };

    if (action === "primary") {
      payload.set_primary = true;
    } else if (action === "remove-primary") {
      payload.set_primary = false;
    } else {
      payload.status = action;
    }

    await dispatch(EditCoupon(payload));
    fetchDetails(pagination.current, pagination.pageSize); // refresh list
  };


  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponentCp
        pagination={pagination}
        dataSource={Array.isArray(coupons?.data) ? coupons.data : []}
        columns={columnsCoupons(handleStatusChange, canEdit)}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        onChange={handleTableChange}
        h3heading="Coupons List"
        setState={setSearchQuery}
        loading={loading}
        buttonhead2={canAdd ? "Add Coupon" : null}
        navigateTo2={canAdd ? "/create_coupons/add" : null}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListCoupons;
